import React,{useState,useEffect} from 'react';
import commonStyle from './common/common.scss';
import {connect} from 'react-redux';

function NotFoundComponent(props){
	const {isMobile} = props;
	
	return (
		<div 
			style={{
				height:'100%',
				backgroundImage:isMobile? '' : 'url("https://image1.jdomni.in/jdomni_email/07_1910151936.png"),url("https://image1.jdomni.in/jdomni_email/03_1910152011.png")',
				marginTop : isMobile? '':'-72px',
				backgroundSize: '260px auto, 150px auto',
    			backgroundRepeat: 'no-repeat,no-repeat',
    			backgroundPosition: '-80px bottom, calc(100vw - 90px) bottom'
			}}
		>
			<div
				className={commonStyle['content-wrapper']}
				style={{
					width : '100%',
					height : '100%',
					display : 'flex',
					alignItems : 'center'
				}}
			>
				<div
					style={{
						display : 'flex',
						flexDirection: isMobile ? 'column-reverse' : 'row',
						textAlign: 'center',
						margin:'auto',
						marginTop: isMobile ? '5.5rem' : 'auto',
						justifyContent:'center'	,
						alignItems: 'center',
						width: '90%'				
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							//flex : 1,
							marginTop : isMobile ? 40.7 : 0,
							textAlign : isMobile ? 'center' : 'left',
							marginRight: isMobile? '':'19%',
							minWidth : isMobile?'':'208px'

						}}
					>
						<div
							style={{
								fontSize: isMobile ? 30 : 42,
								color: '#3F4755',
								lineHeight: isMobile ? '41px' : '52.72px',
								fontWeight: 600,
								marginBottom : isMobile ? 3.2 : 10
							}}
						>
						Oops!
						</div>
						<div
							style={{
								fontSize: 18,
								color: '#4E5867',
								lineHeight: '26.88px',
								marginBottom : 35
							}}
						>
						You're not authorised.
						</div>
					</div>
					<div
						style={isMobile ? {
							maxWidth : '280px',
							maxHeight : '174px',
						} : {
							flex:'1'
						}}
					>
						<img 
							src="https://image1.jdomni.in/jdomni_email/11104_2305191216.jpg"
							style={{
								width : isMobile ? '100%' : '100%'	
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

function NotFoundPage(props) {
	return(
		<div 
			className="omni"
			style={{
				display: 'flex',
				flexDirection: 'column',
				height: '100vh'
			}}
		>
			<NotFoundComponent isMobile={props.isMobile} />
		</div>
	)
}

const mapStateToProps = (state) => ({
	isMobile : state.deviceData.isMobile
})

export default connect(mapStateToProps)(NotFoundPage)